var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 8.89543 0.895431 8 2 8L30 8C31.1046 8 32 8.89543 32 10V36H2C0.895431 36 0 35.1046 0 34L0 10Z",
    fill: "url(#paint0_linear_11234_31513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30L4 30V36L48 36V30Z",
    fill: "#B1B0F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0775 16H34V30H48V24.9031C48 23.9948 47.6909 23.1136 47.1235 22.4043L43.201 17.5012C42.4419 16.5524 41.2926 16 40.0775 16Z",
    fill: "#D2D0FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6143 23.2226L41.8564 20.8193C41.4798 20.3044 40.8801 20 40.2421 20H40.2286H38V26H44V24.4034C44 23.9788 43.8649 23.5653 43.6143 23.2226Z",
    fill: "#F7F7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 37C4 39.7614 6.23858 42 9 42C11.7614 42 14 39.7614 14 37C14 34.2386 11.7614 32 9 32C6.23858 32 4 34.2386 4 37Z",
    fill: "#F7F7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 40C7.34315 40 6 38.6569 6 37C6 35.3431 7.34315 34 9 34C10.6569 34 12 35.3431 12 37C12 38.6569 10.6569 40 9 40ZM9 42C6.23858 42 4 39.7614 4 37C4 34.2386 6.23858 32 9 32C11.7614 32 14 34.2386 14 37C14 39.7614 11.7614 42 9 42Z",
    fill: "#B1B0F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37C34 39.7614 36.2386 42 39 42C41.7614 42 44 39.7614 44 37C44 34.2386 41.7614 32 39 32C36.2386 32 34 34.2386 34 37Z",
    fill: "#F7F7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 40C37.3431 40 36 38.6569 36 37C36 35.3431 37.3431 34 39 34C40.6569 34 42 35.3431 42 37C42 38.6569 40.6569 40 39 40ZM39 42C36.2386 42 34 39.7614 34 37C34 34.2386 36.2386 32 39 32C41.7614 32 44 34.2386 44 37C44 39.7614 41.7614 42 39 42Z",
    fill: "#B1B0F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11234_31513",
    x1: 27,
    y1: 2,
    x2: 3.05077,
    y2: 31.7858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608323,
    stopColor: "#D2D0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608423,
    stopColor: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.4a42b0ae99f6e3602682cffedacf33a9.svg";
export { ForwardRef as ReactComponent };